export default "__VITE_ASSET__48ee458e__"